import { useLexicalComposerContext as c } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey as a, $insertNodes as d, COMMAND_PRIORITY_EDITOR as s, createCommand as u } from "lexical";
import { useEffect as N } from "react";
import { Q as D, R as C, S as L, U as k, V as l, X as T, Y as f, Z as g, _ as m } from "./PlaygroundNodes-B1J2GgG-.js";
import { mergeRegister as _ } from "@lexical/utils";
const E = u();
function w() {
  const [e] = c();
  return N(() => {
    if (!e.hasNodes([D]))
      throw new Error("CardLinkPlugin: CardLinkNode not registered on editor");
    return e.registerCommand(
      E,
      ({ cardId: t, tabId: o, nodeKey: i }) => {
        if (i) {
          const r = a(i);
          return C(r) && r.setTarget(t, o), !0;
        }
        return d([L(t, o)]), !0;
      },
      s
    );
  }, [e]), null;
}
const M = u();
function S() {
  const [e] = c();
  return N(() => {
    if (!e.hasNodes([k]))
      throw new Error("DecisionTreeLinkPlugin: DecisionTreeLinkNode not registered on editor");
    return e.registerCommand(
      M,
      ({ decisionTreeId: t, nodeKey: o }) => {
        if (o) {
          const i = a(o);
          return l(i) && i.setTarget(t), !0;
        }
        return d([T(t)]), !0;
      },
      s
    );
  }, [e]), null;
}
const O = u(), p = u(), I = u();
function U() {
  const [e] = c();
  return N(() => {
    if (!e.hasNodes([f]))
      throw new Error("DocumentLinkPlugin: DocumentLinkNode not registered on editor");
    const t = e.registerCommand(
      O,
      (r) => {
        const n = g(r.url, r.displayText);
        return d([n]), !0;
      },
      s
    ), o = e.registerCommand(
      p,
      (r) => (e.update(() => {
        const n = a(r.key);
        n !== null && m(n) && n.setName(r.displayText);
      }), !0),
      s
    ), i = e.registerCommand(
      I,
      (r) => (e.update(() => {
        const n = a(r.key);
        n !== null && m(n) && n.remove();
      }), !0),
      s
    );
    return _(
      t,
      o,
      i
    );
  }, [e]), null;
}
export {
  w as C,
  I as D,
  O as I,
  E as S,
  p as U,
  M as a,
  S as b,
  U as c
};
//# sourceMappingURL=index-DKx_Eaeq.js.map
